/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'

import 'react-three-fiber'

import { toFenceGeometry } from './FenceHelpers'
import BaseLine from '../FieldComponents/BaseLine'
import FoulPole from '../FieldComponents/FoulPole'

function Fence(props) {
    const mesh = useRef()
    const { geometry, distance } = toFenceGeometry({
        venueId: props.venueId,
        squaredSegmentJoins: true,
    })
    return (
        <group>
            <mesh
                useRef={mesh}
                position={props.position || [0, 0, 0]}
                material={
                    new THREE.MeshBasicMaterial({
                        color: 0x77c6bf,
                        // shininess: 1,
                        // specular: '#ffffff',
                        wireframe: false,
                        flatShading: false,
                        wireframeLinewidth: 0.4,
                        transparent: true,
                        side: THREE.DoubleSide,
                        opacity: 1,
                    })
                }
                geometry={geometry}
            />
            <BaseLine {...props} side="l" dist={distance.lf} />
            <BaseLine {...props} side="r" dist={distance.rf} />
            <FoulPole {...props} side="l" dist={distance.lf} />
            <FoulPole {...props} side="r" dist={distance.rf} />
        </group>
    )
}

export default Fence
